// extracted by mini-css-extract-plugin
module.exports = {"section":"gallery_section__oVV4m"};